export const browserPatterns = {
  chrome: /chrome[ /](\d+(\.\d+)?)/i,
  firefox: /firefox[ /](\d+(\.\d+)?)/i,
  safari: /version[ /](\d+(\.\d+)?)/i,
  edge: /edg[ /](\d+(\.\d+)?)/i,
  opr: /opr[ /](\d+(\.\d+)?)/i,
};

export const browserIcons = {
  firefox: "fa-brands fa-firefox-browser",
  chrome: "fa-brands fa-chrome",
  safari: "fa-brands fa-safari",
  edge: "fa-brands fa-edge",
};

export const versionLimits: VersionLimit = {
  chrome: { min: 98, max: 115 },
  firefox: { min: 94, max: 102 },
  edge: { min: 98, max: 115 },
  safari: { min: 15.4, max: 17 },
};

export type VersionLimit = {
  chrome: { min: number; max: number };
  firefox: { min: number; max: number };
  edge: { min: number; max: number };
  safari: { min: number; max: number };
};
